import { AdaLink } from '@betrybe/ada-react';
import type { ReactElement } from 'react';
import { useLocation } from 'react-router-dom';

import { DefaultLayout } from '@/layouts/index';

const PAGE_NOT_FOUND = 'Ops, a página não foi encontrada';

type locationStateProps = {
  title?: string;
};

function Error(): ReactElement {
  const { state } = useLocation<locationStateProps>();

  return (
    <DefaultLayout title={state?.title || PAGE_NOT_FOUND} titleAlign="center">
      <div className="error-container">
        <img src="assets/images/error.svg" alt="Imagem de erro" />

        <div className="error-container__informations">
          Houve um erro ao conectar seus dados com a Trybe. Por favor, tente
          novamente. Em caso do erro persistir, entre em contato conosco pelo
          e-mail
          <AdaLink
            href="mailto:msc@betrybe.com"
            className="error-container__informations--email"
          >
            {' '}
            msc@betrybe.com
          </AdaLink>
        </div>
      </div>
    </DefaultLayout>
  );
}

export default Error;
